import useSWR from 'swr';

import { SWRFetcher } from '@commenda/utils';

import type { IFilingsAuditorSupportedFilingsResponse } from './types';

export function useFilingsAuditorSupportedFilings() {
  const { data, error, isLoading } =
    useSWR<IFilingsAuditorSupportedFilingsResponse>(
      'agent-platform/filings-auditor/supported-filings',
      SWRFetcher({ method: 'GET' })
    );

  return {
    supportedFilings: data?.filings ?? [],
    isLoading,
    error,
  };
}
